<template>
  <div class="myspace" v-if="info">
    <center>
      <img
        style="max-height: 300px; max-width: 100%"
        :src="appLogo"
      />
      <hr />
    </center>
    <div class="container-fluid">
      <div class="row">
         <div class="col-md-6 col-xl-3">
          <div class="card bg-c-darkPink order-card">
            <div class="card-block">
              <h6 class="m-b-20">Crédit du client</h6>
              <h2 class="text-right">
                <!-- <i class="ti-wallet f-left"></i> -->
                <ThemifyIcon class="f-left" icon="wallet" />
                <span style="font-size: 20px">{{ client.credit }} DT</span>
              </h2>
              <p class="m-b-0">{{client.fullname}}</p>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-xl-4">
          <div
            class="card bg-c-blue order-card"
            style="cursor: pointer"
            @click="showProducts(info.deposed)"
          >
            <div class="card-block">
              <h6 class="m-b-20">Articles déposés</h6>
              <h2 class="text-right">
                <!-- <i class="ti-shopping-cart f-left"></i> -->
                <ThemifyIcon class="f-left" icon="tag" />
                <span
                  >{{ info.deposed.length }}
                  {{
                    info.deposed.length > 0
                      ? info.deposed.length > 1
                        ? "Articles"
                        : "Article"
                      : ""
                  }}</span
                >
              </h2>
              <p class="m-b-0">
                Somme
                <span class="f-right">{{ getSumPrices(info.deposed) }} DT</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-xl-4">
          <div
            class="card bg-c-green order-card"
            style="cursor: pointer"
            @click="showProducts(info.sold)"
          >
            <div class="card-block">
              <h6 class="m-b-20">Articles vendus</h6>
              <h2 class="text-right">
                <ThemifyIcon class="f-left" icon="shopping-cart" />
                <span
                  >{{ info.sold.length }}
                  {{
                    info.sold.length > 0
                      ? info.sold.length > 1
                        ? "Articles"
                        : "Article"
                      : ""
                  }}</span
                >
              </h2>
              <p class="m-b-0">
                Somme
                <span class="f-right">{{ getSumPrices(info.sold) }} DT</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-xl-4">
          <div
            class="card bg-c-yellow order-card"
            style="cursor: pointer"
            @click="showProducts(info.inreturn)"
          >
            <div class="card-block">
              <h6 class="m-b-20">Retours</h6>
              <h2 class="text-right">
                <ThemifyIcon class="f-left" icon="reload" />
                <span
                  >{{ info.inreturn.length }}
                  {{
                    info.inreturn.length > 0
                      ? info.inreturn.length > 1
                        ? "Articles"
                        : "Article"
                      : ""
                  }}</span
                >
              </h2>
              <p class="m-b-0">
                Somme
                <span class="f-right"
                  >{{ getSumPrices(info.inreturn) }} DT</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="show">
      <base-table
        class="table align-items-center"
        tbody-classes="list"
        :data="items"
      >
        <template slot="columns">
          <th>Réf</th>
          <th>Article</th>
          <th>En main</th>
          <th>Date dépot</th>
        </template>

        <template slot-scope="{ row }">
          <td class="budget">{{ row.id }}</td>
          <td>{{ row.name }}</td>

          <td>{{ row.price }} DT</td>

          <td>{{ $options.filters.date(row.createdOn) }}</td>
        </template>
      </base-table>
    </div>
  </div>
</template>

<script>
import { get } from "@/mixins/api";
import ThemifyIcon from "vue-themify-icons";
import constants from "@/mixins/constants";
export default {
  name: "myspace",
  mixins: [constants],
  components: {
    ThemifyIcon,
  },
  data() {
    return {
      info: null,
      show: false,
      items: null,
      client: {}
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      get("myproducts/" + this.$route.params.id).then((response) => {
        this.info = response.data;
      });
      get("client/" + this.$route.params.id).then((response) => {
        this.client = response.data.data;
      });
    },
    getSumPrices(array) {
      return array
        .reduce(function (a, b) {
          return (a += b.price);
        }, 0)
        .toFixed(2);
    },
    showProducts(array) {
      this.show = true;
      this.items = array;
      setTimeout(() => {
        window.scrollTo(
          0,
          document.body.scrollHeight || document.documentElement.scrollHeight
        );
      }, 200);
    },
  },
  filters: {
    date: function (value) {
      if (!value) return "";
      const date = new Date(value);
      const tmp = date.toLocaleDateString("fr-FR", { weekday: "long" });
      const day = tmp.charAt(0).toUpperCase() + tmp.slice(1);
      const month = date.toLocaleString("fr-FR", { month: "long" });
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      let currentHour = date.getHours() + "";
      let currentMinute = date.getMinutes() + "";
      if (currentHour.length < 2) currentHour = "0" + currentHour;
      if (currentMinute.length < 2) currentMinute = "0" + currentMinute;
      return (
        day +
        " " +
        dayOfMonth +
        " " +
        month +
        " " +
        year +
        ", " +
        currentHour +
        ":" +
        currentMinute
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.myspace {
  padding-top: 20px;
}
.card .card-block {
  padding: 25px;
}

.order-card {
  color: #fff;
}

.bg-c-blue {
  background: linear-gradient(45deg, #4099ff, #73b4ff);
}
.m-b-20 {
  margin-bottom: 20px;
}
.card {
  border-radius: 5px;
  box-shadow: 0 1px 2.94px 0.06px rgba(4, 26, 55, 0.16);
  border: none;
  margin-bottom: 30px;
  transition: all 0.3s ease-in-out;
}
.card .card-block p {
  line-height: 1.4;
}
.m-b-0 {
  margin-bottom: 0;
}
p {
  font-size: 14px;
}
.order-card i {
  font-size: 26px;
}
.f-left {
  float: left;
}
[class^="ti-"],
[class*=" ti-"] {
  font-family: themify;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ti-wallet:before {
  content: "\e6cd";
}
.ti-wallet:before {
  content: "\e6cd";
}
.ti-shopping-cart:before {
  content: "\e60d";
}
.ti-reload:before {
  content: "\e619";
}
.ti-tag:before {
  content: "\e608";
}
.bg-c-green {
  background: linear-gradient(45deg, #2ed8b6, #59e0c5);
}
.bg-c-yellow {
  background: linear-gradient(45deg, #ffb64d, #ffcb80);
}
.bg-c-pink {
  background: linear-gradient(45deg, #ff5370, #ff869a);
}
h6 {
  font-weight: 600;
}
h6 {
  font-size: 14px;
}
.m-b-0 {
  margin-bottom: 0;
}
p {
  font-size: 14px;
}
.f-right,
.f-left,
.text-right,
.m-b-20 {
  color: white;
}
.f-right {
  float: right;
}
.card .card-block {
  padding: 10px;
}

.order-card {
  color: #fff;
}

.bg-c-blue {
  background: linear-gradient(45deg, #4099ff, #73b4ff);
}
.m-b-20 {
  margin-bottom: 20px;
}
.card {
  border-radius: 5px;
  box-shadow: 0 1px 2.94px 0.06px rgba(4, 26, 55, 0.16);
  border: none;
  margin-bottom: 30px;
  transition: all 0.3s ease-in-out;
}
.card .card-block p {
  line-height: 1.4;
}
.m-b-0 {
  margin-bottom: 0;
}
p {
  font-size: 14px;
}
.order-card i {
  font-size: 26px;
}
.f-left {
  float: left;
}
[class^="ti-"],
[class*=" ti-"] {
  font-family: themify;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ti-wallet:before {
  content: "\e6cd";
}
.ti-wallet:before {
  content: "\e6cd";
}
.ti-shopping-cart:before {
  content: "\e60d";
}
.ti-reload:before {
  content: "\e619";
}
.ti-tag:before {
  content: "\e608";
}
.bg-c-green {
  background: linear-gradient(45deg, #2ed8b6, #59e0c5);
}
.bg-c-yellow {
  background: linear-gradient(45deg, #ffb64d, #ffcb80);
}
.bg-c-pink {
  background: linear-gradient(45deg, #ff5370, #ff869a);
}
.bg-c-darkbleu {
  background: linear-gradient(45deg, #00008b, #b0c4de);
}
.bg-c-darkbleu2 {
  background: linear-gradient(45deg, #6495ed, #b0c4de);
}
.bg-c-darkPink {
  background: linear-gradient(45deg, #ff69b4, #ffb6c1);
}
.bg-c-darkPink2 {
  background: linear-gradient(45deg, #ff1493, #ffb6c1);
}
h6 {
  font-weight: 600;
}
h6 {
  font-size: 12px;
}
.m-b-0 {
  margin-bottom: 0;
}
p {
  font-size: 14px;
}
.f-right,
.f-left,
.text-right,
.m-b-20 {
  color: white;
}
.f-right {
  float: right;
}
</style>
<style lang="scss">
</style>

